onQueryUpdated